import React from 'react'
import {Button, Panel} from 'react-bootstrap'

export default class DataPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: true
    };
  }

  generateErrorOrWarning() {
    const elements = [
      'last_imported_at',
      'audits_last_updated',
      'unprocessed_audits',
      'failed_job_count',
      'thumbnail_last_updated',
      'video_last_updated',
      'vimeo_last_updated'
    ]
    const res = {}
    elements.forEach(ele => (res[ele] = (this._getKlassName(ele) || 'default')))
    return res
  }

  _getKlassName(ele) {
    const data = this.props.data;
    switch(ele) {
      case 'last_imported_at':
        if(data.last_imported.delay>2) {
          return 'danger'
        if(data.last_imported.delay>1) {
          return 'warning'
        }
        }else {
          return
        }
      default:
        return;
    }
  }

  _getPanelKlassName(errorOrWarning) {
    let values = Object.values(errorOrWarning)
    if(values.includes('danger')) {
      return 'danger'
    }else if(values.includes('warning')) {
      return 'warning'
    }else {
      ''
    }
  }

  render() {
    const data = this.props.data;
    const errorOrWarning = this.generateErrorOrWarning();
    const panelKlassName = this._getPanelKlassName(errorOrWarning);

    return (
      <div className='DataPanel'>
        <Panel id="collapsible-panel-example-2" defaultExpanded={this.state.open} bsStyle={panelKlassName}>
          <Panel.Heading>
            <Panel.Title toggle>
              SHOGUN DATA
            </Panel.Title>
          </Panel.Heading>
          <Panel.Collapse>
            <Panel.Body>
              <h6 className='title'>Game Import</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.last_imported_at}`}>
                  Last Imported At :
                </dt>
                <dd className={`text-${errorOrWarning.last_imported_at}`}>{data.last_imported.at}</dd>

                <dt>Game :</dt>
                <dd>{data.last_imported.game}</dd>
              </dl>
<hr />
            </Panel.Body>
          </Panel.Collapse>
        </Panel>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/components/Shogun/DataPanel.jsx